module.exports = __webpack_public_path__ + "b16e738c2e7808f55c9929e0c6d6ffe9.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/category-1.jpg
// module id = ./assets/images/category-1.jpg
// module chunks = 0